import { loadTime } from './terminal';
import clickUrl from './sounds/click.wav';

const audioCtx = new AudioContext();
const masterGain = audioCtx.createGain();
masterGain.gain.value = 0.5;
masterGain.connect(audioCtx.destination);

async function loadClickBuffer() {
  const response = await fetch(clickUrl);
  const bytes = await response.arrayBuffer();
  return audioCtx.decodeAudioData(bytes);
}

const sounds = {
  click: null as AudioBuffer | null,
};

loadClickBuffer().then((buffer) => {
  sounds.click = buffer;
});

function randomInRange(min: number, max: number) {
  return Math.random() * (max - min) + min;
}

export function playClickSound() {
  if (!sounds.click) return;
  const source = audioCtx.createBufferSource();
  const gain = audioCtx.createGain();
  gain.gain.value = 0.5;
  source.detune.value = randomInRange(-100, 100);
  source.playbackRate.value = randomInRange(0.95, 1.05);
  source.buffer = sounds.click;
  source.connect(gain);
  gain.connect(masterGain);
  source.start();
  source.onended = () => {
    source.disconnect();
    gain.disconnect();
  };
}

export function playTypingSound() {
  if (!sounds.click) return;
  const source = audioCtx.createBufferSource();
  const gain = audioCtx.createGain();
  gain.gain.value = 0.5;
  source.detune.value = randomInRange(-100, 100) - 500;
  source.playbackRate.value = randomInRange(0.95, 1.05);
  source.buffer = sounds.click;
  source.connect(gain);
  gain.connect(masterGain);
  source.start();
  source.onended = () => {
    source.disconnect();
    gain.disconnect();
  };
}

export function playQuietTypingSound() {
  if (!sounds.click) return;
  const source = audioCtx.createBufferSource();
  const gain = audioCtx.createGain();
  gain.gain.value = 0.2;
  source.detune.value = randomInRange(-100, 100) - 600;
  source.playbackRate.value = randomInRange(0.95, 1.05);
  source.buffer = sounds.click;
  source.connect(gain);
  gain.connect(masterGain);
  source.start();
  source.onended = () => {
    source.disconnect();
    gain.disconnect();
  };
}

export function playLoadingSound() {
  const clickBuffer = sounds.click;
  if (!clickBuffer) return;

  const duration = loadTime / 1000;
  const interval = 0.0667;
  const startTime = audioCtx.currentTime;
  const steps = Math.floor(duration / interval);

  let t = startTime;
  for (let i = 0; i <= steps; i++) {
    const source = audioCtx.createBufferSource();
    const gain = audioCtx.createGain();
    const progress = i / steps;
    gain.gain.value = 0.4 + progress * 0.1;

    source.buffer = clickBuffer;
    source.connect(gain);
    gain.connect(masterGain);
    source.start(t);
    source.onended = () => {
      source.disconnect();
      gain.disconnect();
    };

    t += interval;
  }
}

function noteToHz(noteNum: number) {
  // Convert MIDI note number to frequency in Hz
  return 440 * Math.pow(2, (noteNum - 69) / 12);
}

function noteNameToNoteNum(noteName: string) {
  // Convert note name (e.g., "C4", "A#3") to
  // MIDI note number
  const noteMap: { [key: string]: number } = {
    'C': 0,
    'C#': 1,
    'D': 2,
    'D#': 3,
    'E': 4,
    'F': 5,
    'F#': 6,
    'G': 7,
    'G#': 8,
    'A': 9,
    'A#': 10,
    'B': 11,
    'Db': 1,
    'Eb': 3,
    'Gb': 6,
    'Ab': 8,
    'Bb': 10, // Enharmonic equivalents
  };
  const match = noteName.match(/^([A-G][#b]?)(\d)$/);
  if (!match) {
    throw new Error(`Invalid note name: ${noteName}`);
  }
  const note = match[1]!;
  const octave = parseInt(match[2]!, 10);
  return noteMap[note]! + (octave + 1) * 12;
}

export function playBootupSound() {
  const oscillator = audioCtx.createOscillator();
  // play arpeggiated notes C F Bb D
  const notes = ['C3', 'F3', 'Bb3', 'D4', 'C5'];
  const noteDuration = 0.15;
  let currentTime = audioCtx.currentTime;
  for (let i = 0; i < notes.length; i++) {
    const noteNum = noteNameToNoteNum(notes[i]!);
    oscillator.frequency.setValueAtTime(noteToHz(noteNum), currentTime);
    currentTime += noteDuration;
  }
  const gain = audioCtx.createGain();
  gain.gain.value = 0.5;
  oscillator.type = 'triangle';
  oscillator.connect(gain);
  gain.connect(masterGain);
  oscillator.start(audioCtx.currentTime);
  // fade out to prevent click
  gain.gain.setValueAtTime(0.5, currentTime - 0.03);
  gain.gain.linearRampToValueAtTime(0, currentTime);
  oscillator.stop(currentTime + 0.005);
  oscillator.onended = () => {
    oscillator.disconnect();
  };
}
